import { Icon, Tooltip } from "@amzn/storm-ui";
import type { IconDefinition } from "@amzn/storm-ui-icons";
import React from "react";
import styled from "styled-components";

const StyledIcon = styled.div<{ $disabled?: boolean }>`
    &:hover {
        opacity: ${(props) => (props.$disabled ? "0.5" : "0.8")};
    }
`;

const TooltipContent = styled.div`
    padding: 12px;
    max-width: 300px;
`;

interface IconProps {
    icon: IconDefinition;
    tooltipElement: JSX.Element;
    testIdPrefix?: string;
}

export const IconWithTooltip: React.FC<IconProps> = ({
    icon,
    tooltipElement,
    testIdPrefix = "icon-with-tooltip",
}) => {
    const trigger = (
        <StyledIcon>
            <Icon
                type={icon}
                size="small"
                data-testid={`${testIdPrefix}-${icon.iconName}-icon`}
            />
        </StyledIcon>
    );

    return (
        <Tooltip
            data-testid={`${testIdPrefix}-tooltip`}
            trigger={trigger}
            position="top"
        >
            <TooltipContent data-testid={`${testIdPrefix}-tooltip-content`}>
                {tooltipElement}
            </TooltipContent>
        </Tooltip>
    );
};
